import axios from "axios";
import { API_URL } from "../constants/API";

const config = {
  baseURL: API_URL
};

export default axios.create(config);
